import type { FaireProductEntity } from "../../entity_types/product";

export const p_r2qkctrakp: FaireProductEntity = {
  token: "p_r2qkctrakp",
  type: "product",
  name: "Blackberry Hibiscus Energy - Wholesale",
  brandToken: "b_7piiqmq04r",
  brandName: "Lake & Oak Tea Co.",
  imageUrl: "https://cdn.faire.com/fastly/a42a6b5665b29bd2ec285f5cda11effe866b9df60e8ba07e66c9f53e2c58d44b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/46948837d6da3f36b7047c90059ce78c15216a0c173e5d4518118ca3ce937d09.jpeg"
  ],
  priceDollars: 9.8,
  description: "SUPERFOOD TEA BLEND \n\nDrench yourself in berries with this superfruit tea blend that’s dripping with antioxidants from blackberry, elderberry and currant. Yerba mate, black tea and ginkgo bolster brain health and act as nature’s energy drink. Beauty and brains… I'll drink to that! \n\n100% ORGANIC - NUTRITIONIST FORMULATED - SUGAR FREE \n\nHow to Enjoy:\n\n * Steep 1 tsp tea in 1 cup of boiling water for at least 5 minutes. Sweeten to taste. \n * Steep 2 heaping teaspoons of tea in ¾ cup boiling water for at least 5 minutes. Sweeten to taste. Top with 1 cup of ice to cool. \n * In a large jar, combine 3 tbsp of tea for 1 litre of water. Refrigerate overnight, or up to 2 days. Strain, sweeten and enjoy. \n * Steep tea double strength and top with sparkling water, fruits and herbs. We love fresh berries and mint! \nWhen to Steep:\n\n * As a part of your daily hydration ritual \n * For a boost before a workout \n * To beat the afternoon slump \n * As a healthy superfood mocktail \n * Served as a summer garden party sip, at picnic, BBQ, or brunch \n\n\nModerate Caffeine \n",
  tags: [],
  msrpDollars: 15.5,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:45.104Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
